import React from 'react';
import { CheckIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export const BonusesSection = () => {
  return <section className="bg-familia-light py-12 md:py-16 px-4 md:px-6 overflow-hidden" data-id="element-35" data-mp="gwx3kxxwuxbm">
      <div className="max-w-7xl mx-auto w-full" data-id="element-36" data-mp="vtxreqcze84t">
        <div className="text-center mb-6 md:mb-14" data-id="element-37" data-mp="vqjo9fwhtuwb">
          <h2 className="text-[26px] sm:text-3xl md:text-5xl font-display font-bold text-familia-ink mb-3 md:mb-5" data-id="element-38" data-mp="qt082ag8j81q">
            🎁 Más 3 bonos exclusivos
          </h2>
          <p className="text-body text-familia-inkMuted" data-id="element-39" data-mp="zv13d1rwrk0r">
            Incluidos con tu compra de hoy.
          </p>
        </div>
        {/* pt-4 deja lugar a la etiqueta "BONO" dentro del carrusel mobile */}
        <div className="no-scrollbar flex overflow-x-auto snap-x snap-mandatory gap-3 -mx-4 px-4 scroll-px-4 pt-4 md:mx-0 md:px-0 md:overflow-visible md:grid md:grid-cols-3 md:gap-8" data-id="element-40" data-mp="19k134ne8ijg0">
          {bonuses.map(b => <article key={b.num} className="snap-start shrink-0 w-[82%] md:w-auto bg-familia-lightCard border border-familia-lightBorder p-6 md:p-8 rounded-2xl relative flex flex-col" data-id="element-41" data-mp="1jj9wpf56tw1u">
              <div className="absolute -top-3 left-6 md:left-8 bg-familia-gold text-familia-ctaInk font-bold text-[13px] py-1 px-3 rounded" data-id="element-42" data-mp="3trdt5uq9hd45">
                BONO {b.num}
              </div>
              <div className="text-4xl md:text-5xl mb-4 md:mb-5 mt-2" aria-hidden="true" data-id="element-43" data-mp="7kfkszyt0dnb">
                {b.icon}
              </div>
              <h3 className="text-xl md:text-2xl font-display font-bold text-familia-ink mb-1" data-id="element-44" data-mp="cj0juw2bkra6">
                {b.title}
              </h3>
              <p className="text-familia-inkMuted text-[14px] font-semibold uppercase tracking-wide mb-3" data-id="element-45" data-mp="gj0x4ddomwfn">
                {b.subtitle}
              </p>
              <p className="text-body text-familia-inkMuted mb-6 flex-grow" data-id="element-46" data-mp="qa5f7lynmxep">
                {b.desc}
              </p>
              <div className="flex items-center gap-2 pt-4 md:pt-5 border-t border-familia-lightBorder text-familia-check font-bold text-[16px] tracking-wide" data-id="element-47" data-mp="vbumqrmo4sy1">
                INCLUIDO
                <CheckIcon className="w-5 h-5" strokeWidth={3} aria-hidden="true" data-id="element-48" data-mp="am0kkeu1a578" />
              </div>
            </article>)}
        </div>
      </div>
    </section>;
};